import { getUrl } from '../utils/getUrl';
import { headers } from './account';

export const getExploreEntries = async (type: number, since?: string) => {
  let dateParam = !since ? '' : `&filterDate=${since}`;
  return fetch(`${getUrl()}/api/explore/entries?filter=${type}${dateParam}`, {
    headers,
  }).then((res) => res.json());
};

export const getExploreStages = async (type: number) =>
  fetch(`${getUrl()}/api/explore/accounts?filter=${type}`, {
    headers,
  }).then((res) => res.json());

export const getSuggestedStages = async (handles?: string[]) => {
  const handleParam = !handles ? '' : `?subscribedStages=${handles}`;
  return fetch(`${getUrl()}/api/suggestion/stage${handleParam}`, {
    headers,
  }).then((res) => res.json());
};

export const getSuggestedEntries = async () =>
  fetch(`${getUrl()}/api/suggestion/entries/`, {
    headers,
  }).then((res) => res.json());
